import constants from './auth.constants';

const initialState = {
	loggingIn: false,
	loggedIn: false,
	unauthorized: false,
	user: null,
}

export function authentication(state=initialState, action) {
	switch(action.type) {
		case constants.AUTH_LOGIN_REQUEST:
			return {
				loggingIn: true,
				user: action.user
			}
		case constants.AUTH_LOGIN_SUCCESS:
			return {
				loggedIn: true,
				loggingIn: false,
				user: action.user
			}
		case constants.AUTH_LOGIN_FAILURE:
			return {
				loggedIn: false,
				loggingIn: false,
				loginMessage: action.error,
				user: null
			}
		case constants.AUTH_LOGOUT:
			return {
				loginMessage: action.message
			}
		case constants.API_UNAUTHENTICATED:
			return {
				loggedIn: false,
				loggingIn: false,
				loginMessage: 'Your session expired, please login again',
				user: null,
			}
		case constants.API_UNAUTHORIZED:
			return {
				...state,
				unauthorized: true,
			}
		case "@@router/LOCATION_CHANGE": 
			return {
				...state,
				unauthorized: false,
			}
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/modules/auth/auth.reducer.js